<span *ngIf="errorMessage$ | async as error" class="form-error">
  {{ error }}
</span>
